import React, { useContext, useEffect, useState } from 'react';
import './importDeFichiers2.scss';
import AppelerApi from '../../../services/appeler-api.service';
import { Box, Button, Modal, Snackbar, TextField } from '@mui/material';
import UploadIcone from '@mui/icons-material/CloudUpload';
import ChoisirIcone from '@mui/icons-material/Input';
import Select from 'react-select';
import debounce from 'lodash.debounce';
import { baseSelectionneeContext } from '../../../App';
import * as iconv from 'iconv-lite';
import { Buffer } from 'buffer';

const ImportDeFichiers2 = () => {
    const { baseSelectionnee } = useContext(baseSelectionneeContext);
    const [valeurEntree, _] = useState('');
    const [afficherEnregistrement, setAfficherEnregistrement] = React.useState(false);
    let [clients, setClients] = useState([]);
    let [groupes, setGroupes] = useState([]);
    let [client, setClient] = useState('');
    let [messageOuvert, setMessageOuvert] = useState(false);
    let [message, setMessage] = useState('');

    const listeCriteres = [{ value: 'LOGIN', label: 'Client par login' }, { value: 'DEMO', label: 'Clients démo ou test' },
        { value: 'DANS_ADMIN', label: 'Clients ayant un admin' }, { value: 'ADMIN', label: 'Comptes admin' }, { value: 'GROUPE', label: 'Clients par groupe' }];
    let [critere, setCritere] = useState(listeCriteres[0]);

    const modifierCritere = (critere) => {
        setCritere(critere);
        chercherSalon(critere); // Pour critères sans filtre associé
        if (critere.value === 'GROUPE') {
            AppelerApi.get('/lire-groupes').then(data => {
                setGroupes(data.groupes.map(groupe => { return { value: groupe.IDGroupe, label: groupe.Nom } }));
            });
        }
    };

    const rechercheParChaine = debounce((chaine, critereOptionnel) => {
        chercherSalon(critereOptionnel ?? critere, chaine);
    }, 500);

    const chercherSalon = (critere, valeurFiltre) => {
        switch (critere.value) {
            case 'LOGIN':
                if (!valeurFiltre || valeurFiltre.length < 3) {
                    return;
                }
                AppelerApi.get('/lire-clients-par-enseigne', { enseigne: valeurFiltre }).then(data => {
                    setClients(data.clients);
                });
                return;
            case 'DEMO':
                AppelerApi.get('/lire-clients-demo').then(data => {
                    setClients(data.clients);
                });
                return;
            case 'DANS_ADMIN':
                AppelerApi.get('/lire-clients-dans-admin').then(data => {
                    setClients(data.clients);
                });
                return;
            case 'ADMIN':
                AppelerApi.get('/lire-admins').then(data => {
                    setClients(data.clients);
                });
                return;
            case 'GROUPE':
                if (!valeurFiltre) {
                    return;
                }
                AppelerApi.get('/lire-clients-par-groupe', { IDGroupe: valeurFiltre.value }).then(data => {
                    setClients(data.clients);
                });
                return;
        }
    };

    const selectionnerClient = (enseigne) => {
        setClient(enseigne);
    };

    const gererUpload = (type) => {
        let url = '';
        switch (type) {
            case 'clients':
                url = '/importer-clients';
                break;
            case 'produits':
            default:
                url = '/importer-produits';
        }
        return (event) => {
            if (!event.target.files || event.target.files.length === 0) {
                return;
            }
            const fichier = event.target.files[0];
            const reader = new FileReader();

            reader.onloadend = () => {
                const texteCsv = iconv.decode(Buffer.from(reader.result), 'win1252');
                AppelerApi.post(url, { enseigne: client, fichier: texteCsv }).then(res => {
                    if (res.erreur) {
                        setMessage(res.erreur);
                    } else {
                        setMessage('Import effectué');
                        setAfficherEnregistrement(true);
                    }
                    setMessageOuvert(true);
                });
                event.target.value = '';
            };
        
            reader.readAsArrayBuffer(fichier);
        };
    };

    const masquerEnregistrement = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAfficherEnregistrement(false);
    };

    useEffect(() => {
    }, [valeurEntree, baseSelectionnee]);

    return (
        <div className="conteneur-importDeFichiers2">
            <h1>Import de données</h1>
            <div className="page">
                <div className="bloc-recherche">
                    <div className="recherche-client">
                        <h3>Recherche</h3>
                        <Select
                            placeholder="Critère"
                            className="selection"
                            value={critere}
                            options={listeCriteres}
                            onChange={modifierCritere}
                        />
                        { (critere.value === 'LOGIN') &&
                            <TextField onChange={event => rechercheParChaine(event.target.value)} className="saisie-une-ligne"/>
                        }
                        { (critere.value === 'GROUPE') &&
                            <Select
                                className="selection"
                                options={groupes}
                                onChange={e => chercherSalon(critere, e)}
                            />
                        }
                    </div>
                    {
                    (<div className="tableau-clients"><table>
                        <thead>
                            <tr>
                                <th scope="col">Salon</th>
                                <th scope="col">Sélectionner</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(clients).map(([index, client]) =>
                                <tr key={client.ID_Enseigne} className="ligne-activation">
                                    <td>{client.ID_Enseigne}</td>
                                    <td><ChoisirIcone className="icone" onClick={_ => selectionnerClient(client.ID_Enseigne)}/></td>
                                </tr>
                            )}
                        </tbody>
                    </table></div>)
                    }
                </div>
                <div className="bloc-imports">
                    {(client !== '' &&
                    <div className="imports">
                        <h2>Salon {client}</h2>
                        <div className="champ-saisie">
                            <label>Import de produits</label>
                            <UploadIcone onClick={() => document.getElementById('fichier-produits').click()}/>
                            <input type="file" hidden accept="application/csv" id="fichier-produits" onChange={gererUpload('produits')}/>
                        </div>
                        <div className="champ-saisie">
                            <label>Import de clients</label>
                            <UploadIcone onClick={() => document.getElementById('fichier-clients').click()}/>
                            <input type="file" hidden accept="application/csv" id="fichier-clients" onChange={gererUpload('clients')}/>
                        </div>
                    </div>
                    )}
                </div>
            </div>
            <Snackbar className="notification" open={afficherEnregistrement} onClose={masquerEnregistrement} autoHideDuration={1500} message={'Modification enregistrée'}/>
            <Modal open={messageOuvert} onClose={() => setMessageOuvert(false)}>
                <Box className="pop-up">
                    <p>{message}</p>
                    <div className="boutons-pop-up">
                        <Button onClick={() => setMessageOuvert(false)}>Fermer</Button>
                    </div>
                </Box>
            </Modal>
        </div>
    );
};

export default ImportDeFichiers2;